(() => {
  const MODAL_ID = 'PokespottFormSuccessModal';
  const DEFAULT_TITLE = 'Demande envoyée';
  const DEFAULT_MESSAGE = 'Merci ! Nous revenons vers vous rapidement.';
  const SUCCESS_PATTERN = /merci|thank you|thanks for|envoy|reçu|submitted|submission received|message envoy|demande envoy/i;
  const SHOWN_KEY = 'pokespott-form-success-shown';

  const TEMPLATE_COPY = {
    'page.contact': {
      title: 'Message envoyé',
      message: DEFAULT_MESSAGE,
    },
    'page.rachat-collection': {
      title: 'Demande de rachat envoyée',
      message: 'Merci ! Nous revenons vers vous rapidement. Pensez à envoyer vos photos par e-mail.',
    },
    'page.b2b': {
      title: 'Demande professionnelle envoyée',
      message: DEFAULT_MESSAGE,
    },
    'page.professionnels': {
      title: 'Demande professionnelle envoyée',
      message: DEFAULT_MESSAGE,
    },
  };

  let modalOpen = false;
  let shopifyFormsHandled = false;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getTemplateCopy() {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    return TEMPLATE_COPY[template] || { title: DEFAULT_TITLE, message: DEFAULT_MESSAGE };
  }

  function markShown() {
    try {
      sessionStorage.setItem(SHOWN_KEY, window.location.href);
    } catch (_error) {
      /* ignore */
    }
  }

  function alreadyShownForCurrentUrl() {
    try {
      return sessionStorage.getItem(SHOWN_KEY) === window.location.href;
    } catch (_error) {
      return false;
    }
  }

  function openModal(title, message) {
    if (modalOpen || alreadyShownForCurrentUrl()) return;

    const modal = getModal();
    if (!modal) return;

    const titleEl = modal.querySelector('.pokespott-form-modal__title');
    const messageEl = modal.querySelector('[data-pokespott-form-modal-message]');

    if (titleEl) titleEl.textContent = title || DEFAULT_TITLE;
    if (messageEl) messageEl.textContent = message || DEFAULT_MESSAGE;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('pokespott-form-modal-open');

    modalOpen = true;
    markShown();

    const focusTarget = modal.querySelector('.pokespott-form-modal__cta') || modal.querySelector('.pokespott-form-modal__close');
    focusTarget?.focus();
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('pokespott-form-modal-open');
    modalOpen = false;
  }

  function hideInlineSuccess(element) {
    element.classList.add('pokespott-form-modal-source--hidden');
    element.setAttribute('aria-hidden', 'true');
  }

  function readFromElement(source) {
    if (!source || source.classList.contains('pokespott-form-modal-source--hidden')) return false;

    const title = source.dataset.pokespottFormTitle || getTemplateCopy().title;
    const message =
      normalizeText(source.dataset.pokespottFormMessage || source.textContent) ||
      getTemplateCopy().message;

    hideInlineSuccess(source);
    openModal(title, message);
    return modalOpen;
  }

  function readInlineSuccess() {
    const marked = document.querySelector('[data-pokespott-form-success]');
    if (marked && readFromElement(marked)) return true;

    const fallbacks = document.querySelectorAll('.contact-form__success, .pokespott-rachat__success');
    for (const element of fallbacks) {
      if (readFromElement(element)) return true;
    }

    return false;
  }

  function readUrlSuccess() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return false;

    const copy = getTemplateCopy();
    openModal(copy.title, copy.message);
    return modalOpen;
  }

  function queryAllSafe(root, selector) {
    try {
      return Array.from(root.querySelectorAll(selector));
    } catch (_error) {
      return [];
    }
  }

  function elementsMatchingClass(root, fragment) {
    const needle = fragment.toLowerCase();
    return queryAllSafe(root, '[class]').filter((element) => {
      return String(element.className || '')
        .toLowerCase()
        .includes(needle);
    });
  }

  function findShopifyFormSuccess(root) {
    if (!root) return null;

    const candidates = [
      ...elementsMatchingClass(root, 'success'),
      ...queryAllSafe(root, '[data-testid*="success"]'),
      ...queryAllSafe(root, '[role="status"]'),
      ...queryAllSafe(root, '[role="alert"]'),
    ];

    for (const element of candidates) {
      const text = normalizeText(element.textContent);
      if (text.length >= 12 && SUCCESS_PATTERN.test(text)) {
        return text;
      }
    }

    for (const element of queryAllSafe(root, 'h1, h2, h3, p, div')) {
      const text = normalizeText(element.textContent);
      if (text.length >= 12 && text.length <= 280 && SUCCESS_PATTERN.test(text)) {
        const hasForm = element.closest('form') || root.querySelector('form:not([hidden])');
        if (!hasForm || element.querySelector('input, textarea, select, button[type="submit"]') === null) {
          return text;
        }
      }
    }

    return null;
  }

  function collectShadowRoots(node, roots = []) {
    if (!node) return roots;

    if (node.shadowRoot) {
      roots.push(node.shadowRoot);
      queryAllSafe(node.shadowRoot, '*').forEach((child) => collectShadowRoots(child, roots));
    }

    queryAllSafe(node, '*').forEach((child) => collectShadowRoots(child, roots));
    return roots;
  }

  function watchFormsContainer(container) {
    let observer;
    let pollTimer;
    let attempts = 0;

    const check = () => {
      if (shopifyFormsHandled) return;

      const message = findShopifyFormSuccess(container);
      if (message) {
        shopifyFormsHandled = true;
        observer?.disconnect();
        clearInterval(pollTimer);
        openModal('Demande professionnelle envoyée', message);
      }
    };

    check();
    if (shopifyFormsHandled) return;

    observer = new MutationObserver(check);
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    pollTimer = window.setInterval(() => {
      attempts += 1;
      check();
      if (shopifyFormsHandled || attempts >= 120) {
        clearInterval(pollTimer);
        observer?.disconnect();
      }
    }, 500);
  }

  function watchShopifyFormsEmbed(embed) {
    let observer;
    let pollTimer;
    let attempts = 0;

    const rootsFor = () => {
      const roots = new Set([embed]);
      collectShadowRoots(embed).forEach((root) => roots.add(root));
      if (embed.shadowRoot) roots.add(embed.shadowRoot);
      return Array.from(roots);
    };

    const check = () => {
      if (shopifyFormsHandled) return;

      for (const root of rootsFor()) {
        const message = findShopifyFormSuccess(root);
        if (message) {
          shopifyFormsHandled = true;
          observer?.disconnect();
          clearInterval(pollTimer);
          openModal('Demande professionnelle envoyée', message);
          return;
        }
      }
    };

    const attach = () => {
      check();
      if (shopifyFormsHandled) return;

      const root = embed.shadowRoot || embed;
      observer = new MutationObserver(check);
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      pollTimer = window.setInterval(() => {
        attempts += 1;
        check();
        if (shopifyFormsHandled || attempts >= 120) {
          clearInterval(pollTimer);
          observer?.disconnect();
        }
      }, 500);
    };

    if (embed.shadowRoot) {
      attach();
      return;
    }

    const bootObserver = new MutationObserver(() => {
      if (embed.shadowRoot) {
        bootObserver.disconnect();
        attach();
      }
    });
    bootObserver.observe(embed, { childList: true, subtree: true });
    setTimeout(check, 800);
    setTimeout(check, 2000);
  }

  function initShopifyFormsWatchers() {
    document.querySelectorAll('shopify-forms-embed').forEach(watchShopifyFormsEmbed);

    document.querySelectorAll('.shopify-app-block').forEach((block) => {
      if (block.querySelector('shopify-forms-embed')) return;
      watchFormsContainer(block);
    });
  }

  function bindModalEvents() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-pokespott-form-modal-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modalOpen) {
        closeModal();
      }
    });
  }

  function runSuccessDetection() {
    if (modalOpen || alreadyShownForCurrentUrl()) return;
    if (readInlineSuccess()) return;
    readUrlSuccess();
  }

  function init() {
    if (!getModal()) return;

    bindModalEvents();
    runSuccessDetection();
    initShopifyFormsWatchers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      runSuccessDetection();
    }
  });
})();
